import isToday from "date-fns/isToday";
import isYesterday from "date-fns/isYesterday";
import parseISO from "date-fns/parseISO";
import { useMemo } from "react";
import Link from "@/components/link/Link";
import { ARTICLE_LINK_CLICKED, SITE_MAP_MODULE } from "@/constants/amplitude";
import { ArticleInfoT } from "@/types/sitemap";
import { getFormattedDateTime } from "@/utils/date";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import { ShortFormInfoT } from "../../types/sitemap";
import styles from "./sitemap.module.scss";

interface ArticleListProps {
  showDates?: boolean;
  articlesInfo?: ArticleInfoT[] | ShortFormInfoT[];
}
const ArticleList = ({ articlesInfo, showDates }: ArticleListProps) => {
  const yesterdaysArticles = useMemo(() => {
    if (!showDates) return undefined;
    return articlesInfo?.filter(
      (article) =>
        article.lastPublishedAt &&
        isYesterday(parseISO(article.lastPublishedAt))
    );
  }, [articlesInfo, showDates]);

  const todaysArticles = useMemo(() => {
    if (!showDates) return undefined;
    return articlesInfo?.filter(
      (article) =>
        article.lastPublishedAt && isToday(parseISO(article.lastPublishedAt))
    );
  }, [articlesInfo, showDates]);

  const otherArticles = useMemo(() => {
    if (!showDates) return articlesInfo;
    return articlesInfo?.filter((article) => {
      const articleDate = parseISO(article.lastPublishedAt);
      return (
        article.lastPublishedAt &&
        !isToday(articleDate) &&
        !isYesterday(articleDate)
      );
    });
  }, [articlesInfo, showDates]);
  const { logAmplitudeEvent } = useAmplitude();

  return (
    <div className={styles.container}>
      {otherArticles?.map((article) => (
        <p className={styles.articleLink} key={article.slug}>
          <Link
            next
            onClick={() =>
              logAmplitudeEvent(ARTICLE_LINK_CLICKED, {
                "Link Text": article.title,
                "Link URL": `/${article.slug}`,
                Module: SITE_MAP_MODULE,
                Competition: article.sport?.name,
              })
            }
            href={`/${article.slug}`}
          >
            {article.title}
          </Link>
          {article.lastPublishedAt && showDates ? (
            <span className={styles.smallDate}>
              {getFormattedDateTime(article.lastPublishedAt)}
            </span>
          ) : undefined}
        </p>
      ))}
      {yesterdaysArticles && yesterdaysArticles.length > 0 ? (
        <div>
          <h2 className={styles.heading}>Yesterday</h2>
          {yesterdaysArticles.map((article) => (
            <p className={styles.articleLink} key={article.slug}>
              <Link
                next
                onClick={() =>
                  logAmplitudeEvent(ARTICLE_LINK_CLICKED, {
                    "Link Text": article.title,
                    "Link URL": `/${article.slug}`,
                    Module: SITE_MAP_MODULE,
                    Competition: article.sport.name,
                  })
                }
                href={`/${article.slug}`}
              >
                {article.title}
              </Link>
            </p>
          ))}
        </div>
      ) : undefined}
      {todaysArticles && todaysArticles.length > 0 ? (
        <div>
          <h2 className={styles.heading}>Today</h2>
          {todaysArticles.map((article) => (
            <p className={styles.articleLink} key={article.slug}>
              <Link
                next
                onClick={() =>
                  logAmplitudeEvent(ARTICLE_LINK_CLICKED, {
                    "Link Text": article.title,
                    "Link URL": `/${article.slug}`,
                    Module: SITE_MAP_MODULE,
                    Competition: article.sport.name,
                  })
                }
                href={`/${article.slug}`}
              >
                {article.title}
              </Link>
            </p>
          ))}
        </div>
      ) : undefined}
    </div>
  );
};
export default ArticleList;
